const redirectionLink = {
    DEVELOPMENT: "https://tclu.tatacapital.com",
    PRODUCTION: "https://www.tatacapital.com"
}

export default redirectionLink;
